import { createReducer, PayloadAction } from '@reduxjs/toolkit';
import * as ActionTypes from '../actions/types';
import {
    ApplicationUsers,
    fetchApplicationCustomerFeedbackSuccessAction,
    fetchApplicationUserDetailsSuccessAction,
    fetchApplicationUserWordingsSuccessAction,
    updateApplicationTermsAndConditionsTermsConsentedSuccessAction,
    UserApplicationUserBody,
} from '../actions/applicationUser';

type State = {
    message: string;
    accessToken: null | string;
    applicationUserDetails: ApplicationUsers | {} | any;
    unAuthorisedDetails: ApplicationUsers | {} | any;
    customerFeedback: null | string | boolean;
    updateConsent: null | string | boolean;
    requestHasFailed: boolean;
    wordings: null | any;
    loading: boolean;
    isUserWordingsLoading: boolean;
};
const INITIAL_STATE: State = {
    message: 'HellO MOTO',
    accessToken: null,
    applicationUserDetails: {},
    unAuthorisedDetails: {},
    customerFeedback: null,
    wordings: null,
    loading: false,
    updateConsent: null,
    requestHasFailed: false,
    isUserWordingsLoading: false,
};

const login = (state: State): State => {
    return state;
};

const loginSucceeded = (
    state: State,
    action: PayloadAction<UserApplicationUserBody>,
): State => {
    return {
        ...state,
        accessToken:
            action.payload &&
            action.payload.accessTokenFromAuthentication &&
            action.payload.accessTokenFromAuthentication.accessToken
                ? action.payload.accessTokenFromAuthentication.accessToken
                : null,
    };
};

const loginFailed = (state: State): State => {
    return state;
};

const updateToken = (
    state: State,
    action: PayloadAction<UserApplicationUserBody>,
): State => {
    return {
        ...state,
        accessToken: action.payload.accessTokenFromAuthentication.accessToken,
    };
};

const fetchApplicationUserDetails = (state: State): State => {
    return {
        ...state,
    };
};

const fetchApplicationUserDetailsSuccess = (
    state: State,
    action: PayloadAction<fetchApplicationUserDetailsSuccessAction>,
): State => {
    return {
        ...state,
        applicationUserDetails: action.payload.body.data,
    };
};

const fetchApplicationUserDetailsFailed = (state: State): State => {
    return {
        ...state,
    };
};

const fetchApplicationCustomerFeedBack = (state: State): State => {
    return {
        ...state,
    };
};
const fetchApplicationCustomerFeedBackSuccess = (
    state: State,
    action: PayloadAction<fetchApplicationCustomerFeedbackSuccessAction>,
): State => {
    return {
        ...state,
        customerFeedback: action.payload.body.data,
    };
};
const fetchApplicationCustomerFeedBackFailed = (state: State): State => {
    return {
        ...state,
    };
};

const updateApplicationTermsConsented = (state: State): State => {
    return {
        ...state,
    };
};
const updateApplicationTermsConsentedSuccess = (
    state: State,
    action: PayloadAction<updateApplicationTermsAndConditionsTermsConsentedSuccessAction>,
): State => {
    return {
        ...state,
        updateConsent: action.payload.body.data,
        requestHasFailed: false,
    };
};
const updateApplicationTermsConsentedFailed = (state: State): State => {
    return {
        ...state,
        requestHasFailed: true,
    };
};
const fetchApplicationUserWordings = (state: State): State => {
    return {
        ...state,
        loading: true,
    };
};
const fetchApplicationUserWordingsSuccess = (
    state: State,
    action: PayloadAction<fetchApplicationUserWordingsSuccessAction>,
): State => {
    return {
        ...state,
        wordings: action.payload.body.data,
        loading: false,
    };
};
const fetchApplicationUserWordingsFailed = (state: State): State => {
    return {
        ...state,
        loading: false,
    };
};

const fetchUnauthorizedUserWordings = (state: State): State => {
    return {
        ...state,
        isUserWordingsLoading: true,
    };
};
const fetchUnauthorizedUserWordingsSuccess = (
    state: State,
    action: PayloadAction<fetchApplicationUserWordingsSuccessAction>,
): State => {
    const data = action.payload.body.data;
    return {
        ...state,
        isUserWordingsLoading: false,
        wordings: data?.wordings ?? null,
        unAuthorisedDetails: {
            languageId: data?.languageId ?? null,
        },
    };
};
const fetchUnauthorizedUserWordingsFailed = (state: State): State => {
    return {
        ...state,
        isUserWordingsLoading: false,
    };
};

const addResourceFileToI18n = (state: State): State => {
    return {
        ...state,
        loading: true,
    };
};

const addResourceFileToI18nSuccess = (state: State): State => {
    return {
        ...state,
        loading: false,
    };
};

const updateLanguageApplicationUser = (state: State): State => {
    return {
        ...state,
        loading: true,
    };
};

const updateLanguageApplicationUserSuccess = (state: State): State => {
    return {
        ...state,
        loading: false,
    };
};
const updateLanguageApplicationUserFailed = (state: State): State => {
    return {
        ...state,
        loading: false,
    };
};
const applicationUser = createReducer(INITIAL_STATE, {
    [ActionTypes.LOGIN]: login,
    [ActionTypes.LOGIN_SUCCEEDED]: loginSucceeded,
    [ActionTypes.LOGIN_FAILED]: loginFailed,
    [ActionTypes.UPDATE_TOKEN]: updateToken,
    [ActionTypes.FETCH_APPLICATION_USER_DETAILS]: fetchApplicationUserDetails,
    [ActionTypes.FETCH_APPLICATION_USER_DETAILS_SUCCESS]:
        fetchApplicationUserDetailsSuccess,
    [ActionTypes.FETCH_APPLICATION_USER_DETAILS_FAILED]:
        fetchApplicationUserDetailsFailed,
    [ActionTypes.FETCH_APPLICATION_CUSTOMER_FEEDBACK]:
        fetchApplicationCustomerFeedBack,
    [ActionTypes.FETCH_APPLICATION_CUSTOMER_FEEDBACK_SUCCESS]:
        fetchApplicationCustomerFeedBackSuccess,
    [ActionTypes.FETCH_APPLICATION_CUSTOMER_FEEDBACK_FAILED]:
        fetchApplicationCustomerFeedBackFailed,
    [ActionTypes.UPDATE_APPLICATION_TERMS_CONSENTED]:
        updateApplicationTermsConsented,
    [ActionTypes.UPDATE_APPLICATION_TERMS_CONSENTED_SUCCESS]:
        updateApplicationTermsConsentedSuccess,
    [ActionTypes.UPDATE_APPLICATION_TERMS_CONSENTED_FAILED]:
        updateApplicationTermsConsentedFailed,
    [ActionTypes.FETCH_APPLICATION_USER_WORDINGS]: fetchApplicationUserWordings,
    [ActionTypes.FETCH_APPLICATION_USER_WORDINGS_SUCCESS]:
        fetchApplicationUserWordingsSuccess,
    [ActionTypes.FETCH_APPLICATION_USER_WORDINGS_FAILED]:
        fetchApplicationUserWordingsFailed,
    [ActionTypes.FETCH_UNAUTHORISED_WORDINGS]: fetchUnauthorizedUserWordings,
    [ActionTypes.FETCH_UNAUTHORISED_WORDINGS_SUCCESS]:
        fetchUnauthorizedUserWordingsSuccess,
    [ActionTypes.FETCH_UNAUTHORISED_WORDINGS_FAILED]:
        fetchUnauthorizedUserWordingsFailed,
    [ActionTypes.ADD_RESOURCE_FILE_TO_I18N]: addResourceFileToI18n,
    [ActionTypes.ADD_RESOURCE_FILE_TO_I18N_SUCCESS]:
        addResourceFileToI18nSuccess,
    [ActionTypes.UPDATE_LANGUAGE_APPLICATION_USER]:
        updateLanguageApplicationUser,
    [ActionTypes.UPDATE_LANGUAGE_APPLICATION_USER_SUCCESS]:
        updateLanguageApplicationUserSuccess,
    [ActionTypes.UPDATE_LANGUAGE_APPLICATION_USER_FAILED]:
        updateLanguageApplicationUserFailed,
});

export default applicationUser;
